import React from 'react';
import Tooltip from 'src/components/tooltip';
import Icon from 'shared/components/icon';
import Stamp from 'src/components/Stamp/Stamp';

interface Props {
  showTooltipFlag: boolean;
}

const NonUsCitizensOnlyText = ({showTooltipFlag = false}: Props) => {
  const infoText = 'Only available to non-US citizens';

  if (!showTooltipFlag) {
    return (
      <Stamp>
        <div className="college-earnings-no-earnings-status-text-content">{infoText}</div>
      </Stamp>
    );
  }

  return (
    <div className="college-earnings-no-earnings-status-text-content">
      <Tooltip title={infoText}>
        <div>
          <Stamp className="flag">
            <Icon iconType="flag" color="grey" />
          </Stamp>
        </div>
      </Tooltip>
    </div>
  );
};

export default NonUsCitizensOnlyText;
